// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2TaZC","title":"Images90_title__1fkiI","images":"Images90_images__-Tssv"};